import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import maybeFormatDate from './maybeFormatDate';

const StackedBarChart = ({ seriesData, rows, colours, title = null, chartHeight = 300, inputType = null }) => {
    const ref = useRef(null);

    const series = seriesData.map(e => {
        const { str } = maybeFormatDate(e.name, inputType);

        return ({
            name: str,
            data: e.data.map(v => v || ''),
            type: 'bar',
            stack: 'total',
            emphasis: {
                focus: 'series'
            },
            label: {
                show: true
            }
        });
    });

    const options = {
        grid: {
            containLabel: true
        },
        legend: {},
        tooltip: {
            trigger: 'item',
            formatter: params => `${params.marker}${params.seriesName}: <b>${params.value}</b>`
        },
        yAxis: {
            type: 'category',
            data: rows,
            axisLabel: {
                interval: 0
            }
        },
        xAxis: {
            type: 'value',
            minInterval: 1
        },
        color: colours,
        series,
        ...(title && {
            title: {
                text: title
            }
        })
    };

    const height = Boolean(chartHeight >= 300) ? chartHeight : 300;

    return (
        <ReactECharts
            option={options}
            style={{ height }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default StackedBarChart;